import React from 'react';
import './skeleton.css'

const TemplateSkeleton = () => {
  return (
    <div className='template'>

    </div>
  )
}

export default TemplateSkeleton